// src/zustand/productStore.ts

import { Size } from "interfaces/ISize";
import { create } from "zustand";

/**
 * Interface for Product state
 */
interface ProductState {
  productIdSelected: number | null;
  setProductSelected: (productIdSelected: number | null) => void;
  isEdited: boolean;
  setEdited: (isEdited: boolean) => void;
  sizes: Size[];
  setSizes: (sizes: Size[]) => void;
}

/**
 * Zustand store for Product
 */
export const useProductStore = create<ProductState>((set) => ({
  productIdSelected: null,
  setProductSelected: (productIdSelected) => set({ productIdSelected }),
  isEdited: false,
  setEdited: (isEdited) => set({ isEdited }),
  sizes: [],
  setSizes: (sizes) => set({ sizes }),
}));
